import AppNav from 'components/base/nav/AppNav';
import AppTemplate from 'components/base/template/AppTemplate';
import ProjectContainerClinic from 'containers/project/clinic/ProjectContainer';
import ProjectListContainerClinic from 'containers/project/clinic/ProjectListContainer';
import CreateProjectContainerLab from 'containers/project/CreateProjectContainer';
import ProjectContainerLab from 'containers/project/ProjectContainer';
import ProjectCreatingContainer from 'containers/project/ProjectCreatingContainer';
import ProjectListContainerLab from 'containers/project/ProjectListContainer';
import { ProjectProvider } from 'contexts/project/ProjectContext';
import { pageUrl } from 'lib/mapper';
import React from 'react';
import { useLocation } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useShallowAppSelector } from 'store/hooks';
import { isClinicUserSelector } from 'store/modules/user';

function Project() {
  const { isFullScreen, isClinicUser } = useShallowAppSelector(state => ({
    isFullScreen: state.file.isFullScreen,
    isClinicUser: isClinicUserSelector(state),
  }));

  const { pathname } = useLocation();

  return (
    <AppTemplate
      title={'Project'}
      leftSide={<AppNav />}
      // rightSide={pathname.includes('/project/detail') && <ExcuteNav />}
      mainContainerStyle={{
        justifyContent: 'space-between',
      }}
      mainStyle={{
        // padding: '0 50px',
        padding: '0 0 0 40px',
      }}
      headerHide={isFullScreen}
    >
      <ProjectProvider>
        <Switch>
          <Redirect exact path={pageUrl.project.index} to={pageUrl.project.list} />
          <Route
            path={pageUrl.project.list}
            component={isClinicUser ? ProjectListContainerClinic : ProjectListContainerLab}
          />
          <Route
            path={pageUrl.project.detail}
            component={isClinicUser ? ProjectContainerClinic : ProjectContainerLab}
          />
          <Route path={pageUrl.project.create.new} component={CreateProjectContainerLab} />
          <Route path={pageUrl.project.create.patient} component={CreateProjectContainerLab} />
          <Route path={pageUrl.project.edit} component={CreateProjectContainerLab} />
          <Route path={pageUrl.project.copy} component={CreateProjectContainerLab} />
          <Route path={pageUrl.project.creating} component={ProjectCreatingContainer} />
          <Route path={pageUrl.project.creatWaiting} component={ProjectCreatingContainer} />
          <Route component={() => <Redirect to={pageUrl.error.notFound} />} />
        </Switch>
      </ProjectProvider>
    </AppTemplate>
  );
}

export default Project;
